import { create } from "zustand";
import { io, Socket } from "socket.io-client";
import { getAvailableReports, Report } from "services/input-core/reports/get-available-reports";

interface ReportsState {
  isLoadingReport: boolean;
  setIsLoadingReport: (loading: boolean) => void;
  socket: Socket | null;
  connectSocket: (email: string) => void;
  disconnectSocket: () => void;
  socketNotification: () => void;
  getReportsList: () => void;
  reportsList: Report[] | undefined;
  isLoadingReportList: boolean;
  setIsLoadingReportList: (loading: boolean) => void;
}

export const useReportsContext = create<ReportsState>((set, get) => ({
  isLoadingReport: false,
  socket: null,
  reportsList: undefined,
  isLoadingReportList: false,
  setIsLoadingReportList: (loading) => set({ isLoadingReportList: loading }),

  setIsLoadingReport: (loading) => set({ isLoadingReport: loading }),

  getReportsList: async () => {
    set({ isLoadingReportList: true });
    const data  = await getAvailableReports();
    set({ reportsList: data });
    set({ isLoadingReportList: false });
  },
  
  connectSocket: (email: string) => {
    const { socket } = get();
    
    if (!socket) {
      const newSocket = io("https://app-unotify-dev-eastus-001-eufse6hdahhka6ez.eastus-01.azurewebsites.net", {
        transports: ["websocket"],
      });

      newSocket.on("connect", () => {
        console.log("Socket connected", email);
        newSocket.emit("report-room", { email });
      });

      set({ socket: newSocket });
    }
  },

  socketNotification: () => {
    const { socket } = get();
    if (socket) {
      console.log("Report received");
      socket.emit("report", { message: "Report received" });
      set({ isLoadingReport: false });
      get().getReportsList();
    }
  },
  
  disconnectSocket: () => {
    const { socket } = get();
    if (socket) {
      socket.disconnect();
      set({ socket: null });
    }
  }
}));